import React, { useEffect } from "react";
import {Redirect, Route, Switch } from "react-router-dom";
import Landing from "./sections/landing";
import Terms from "./sections/terms";
import Approved from "../global-elements/approved/approved2";
import Declined from "../global-elements/declined";
import { useStoreState, useStoreActions } from "easy-peasy";
import DeclinedTemporal from "../global-elements/declinedTemporal";
import '../../../assets/resultPage/resultpage.css';
import Error404 from "../../systempages/error404/Error404";
import GrandBankPage from "../global-elements/grandbank/grandbankPage";
import Offer from "./sections/offer";
import LinkBankAccount from '../linkBankAccount/linkBankAccount';
import { InactiveDetection } from "../../../services/inactiveDetection";
import ApprovedGrandBank from "../global-elements/approved/approved_grandbank";
import TermsGrandBank from "./sections/terms-grandbank";
import OfferGrandBank from "./sections/offer-grandbank";
import PDFTerms from "../global-elements/PDFTerms";
import { PRODUCT } from "../../../models/websiteTypesConstants";

function Layout() {
  const brandSettings = useStoreState(
    (state) => state.siteSettingsModel.brandSettings
  );
  const MainPath      = useStoreState(state => state.siteSettingsModel.MainPath);
  const PathBasedSite = useStoreState(state => state.siteSettingsModel.PathBasedSite);
  const termsStep = useStoreState(state => state.displayPrequalTerms);
  const resultStep = useStoreState(state => state.displayResult);

  const setProductPath = useStoreActions(actions => actions.siteSettingsModel.setMainPath);

  // Classic sites can live at the domain root (/terms) or under a path (/AF195/terms)
  const basePath = PathBasedSite ? "/:MainPath" : "";
  const homePath = PathBasedSite ? "/" + window.location.pathname.split('/')[1] : "/";

  InactiveDetection.setInactiveTitle(null);
  useEffect(() => {
    document.querySelector("title").textContent = `${brandSettings.ProductName} - Mastercard`;
    InactiveDetection.setTitle(`${brandSettings.ProductName} - Mastercard`);
    if(MainPath === "/" && PathBasedSite === true){
      setProductPath("/" + window.location.pathname.split('/')[1] + "/");
    }
  }, [brandSettings, PathBasedSite]);

  return (
    <Switch>
      <Route path={basePath + "/getTerms/:productCode"} component={() => <PDFTerms />} exact />
      {PathBasedSite && <Route path="/" component={() => <Redirect to={homePath + window.location.search} />} exact />}
      {/* Landing page No form */}
      <Route path={basePath || "/"} component={() => <Landing />} exact />
      {/* Reservation Page */}
      <Route path={basePath + "/offer"} component={() => brandSettings.ProductName === PRODUCT.Grand.bank ?  <OfferGrandBank /> : <Offer />} exact />
      {/* Terms page No form */}
      <Route path={basePath + "/terms"} component={() => (termsStep) ? (brandSettings.ProductName === PRODUCT.Grand.bank ? <TermsGrandBank /> : <Terms />) : <Redirect to={homePath + window.location.search} />} exact />
      {/* Approved Page */}
      <Route path={basePath + "/approved"} component={() => (resultStep) ? (brandSettings.ProductName === PRODUCT.Grand.bank ? <ApprovedGrandBank /> : <Approved />) : <Redirect to={homePath + window.location.search} />} exact />
      {/* Terms page No form */}
      <Route path={basePath + "/decision"} component={() => (resultStep) ? <Declined /> : <Redirect to={homePath + window.location.search} />} exact />
      <Route path={basePath + "/grandbank"} component={() => (resultStep) ? <GrandBankPage /> : <Redirect to={homePath + window.location.search} />} exact/>
      <Route path={basePath + "/pendinfo"} component={() => (resultStep) ? <DeclinedTemporal /> : <Redirect to={homePath + window.location.search} />} exact />
      <Route path={basePath + "/link-account"} component={() => (resultStep) ? <LinkBankAccount /> : <Redirect to={homePath + window.location.search} />} exact />
      <Route  component={() => <Error404 />}  />
    </Switch>
  );
}

export default Layout;
